import GlobalEvents from './GlobalEvents.vue'
import BaseConsentGate from './BaseConsentGate.vue'

const globalComponents = [
  GlobalEvents,
  BaseConsentGate,
]

export default globalComponents
